import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3.60698 5.34063L8 9.36757L12.393 5.34063C12.6461 5.10865 13.0509 5.10865 13.3039 5.34063C13.5654 5.58025 13.5654 5.97526 13.3039 6.21489L8.45546 10.6593C8.2024 10.8913 7.79761 10.8913 7.54454 10.6593L2.69605 6.21489C2.43465 5.97526 2.43465 5.58025 2.69605 5.34063C2.94912 5.10865 3.35391 5.10865 3.60698 5.34063Z",
            fill: props.color || "white"
        })
    }));
};
export default Icon;
